import React from 'react';
import HomePage from './home/HomePage';

const ResponsiveLandingPage = () => {
  // 토스 "Simple is the Best" 철학: 검증된 HomePage 재사용
  // 랜딩페이지와 홈페이지의 일관된 사용자 경험 제공
  return <HomePage isLandingPage={true} />;
};

export default ResponsiveLandingPage; 